function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Dropdown = /*#__PURE__*/function () {
  function Dropdown(element) {
    _classCallCheck(this, Dropdown);

    this._element = element;
    this.triggerElement = this._element.querySelector("[data-vanilla-dropdown-trigger]") || this._element.querySelector("[vanilla-dropdown-trigger]");

    this._bind();

    this.isOpen = false;
  }

  _createClass(Dropdown, [{
    key: "open",
    value: function open(e) {
      e.stopPropagation();
      this.isOpen = true;
      this.preOpen();

      this._element.classList.add("is-open");

      this.onOpen();
    }
  }, {
    key: "close",
    value: function close(e) {
      this.isOpen = false;

      this._element.classList.remove("is-open");

      this.onClose();
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      this.isOpen ? this.close(e) : this.open(e);
    }
  }, {
    key: "preOpen",
    value: function preOpen() {}
  }, {
    key: "onOpen",
    value: function onOpen() {} //callback

  }, {
    key: "onClose",
    value: function onClose() {} //callback

  }, {
    key: "_bind",
    value: function _bind() {
      var _this = this;

      if (this.triggerElement != null) {
        this.triggerElement.addEventListener("click", function (e) {
          return _this.toggle(e);
        });
      }
    }
  }]);

  return Dropdown;
}();

export { Dropdown as default };